import { supabase } from '../../supabase.client';
export function useSharedExperiencesApi() {
  const fetchSharedExperiencesByUserId = async (userId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experiences_list_by_user_id', {
        arg_user_id: userId
      });
      if (error) {
        console.error('Error in getSharedExperiences:', error);
        return [];
      }
      return data || [];
    } catch (e) {
      console.error('Error in getSharedExperiences:', e);
      return [];
    }
  };
  const fetchSharedExperiencesByOrganisation = async (organisationId, userId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_list_by_organisation_id', {
        arg_organisation_id: organisationId,
        arg_user_id: userId
      });
      if (error) {
        console.error('Error in getSharedExperiencesByOrganisation:', error);
        return [];
      }
      return data || [];
    } catch (e) {
      console.error('Error in getSharedExperiencesByOrganisation:', e);
      return [];
    }
  };
  const fetchSharedExperienceById = async (id) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_by_id', {
        arg_shared_experiences_id: id
      });
      if (error) {
        console.error('Error in getSharedExperienceById:', error);
        return null;
      }
      return data && data.length > 0 ? data[0] : null;
    } catch (e) {
      console.error('Error in getSharedExperienceById:', e);
      return null;
    }
  };
  const createSharedExperience = async (sharedExperienceData) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences')
        .insert([sharedExperienceData])
        .select()
        .single();
      if (error) {
        console.error('Error in createSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in createSharedExperience:', e);
      throw e;
    }
  };
  const updateSharedExperienceName = async (id, name) => {
    try {
      const { error } = await supabase.rpc('update_shared_experience_name', {
        arg_shared_experiences_id: id,
        arg_name: name
      });
      if (error) {
        console.error('Error in updateSharedExperienceName:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in updateSharedExperienceName:', e);
      throw e;
    }
  };
  const updateAccessLevel = async (accessLevel, sharedExperienceId) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences')
        .update({ access_level: accessLevel })
        .eq('id', sharedExperienceId)
        .select();
      if (error) {
        console.error('Error in updateAccessLevel:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in updateAccessLevel:', e);
      throw e;
    }
  };
  const deleteSharedExperience = async (id) => {
    try {
      const { error } = await supabase.rpc('delete_shared_experiences', {
        arg_shared_experiences_id: id
      });
      if (error) {
        console.error('Error in deleteSharedExperience:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in deleteSharedExperience:', e);
      throw e;
    }
  };
  const fetchSharedExperienceGroups = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_experience_groups_by_shared_experiences_id', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in getSharedExperienceGroups:', error);
        return [];
      }
      return data || [];
    } catch (e) {
      console.error('Error in getSharedExperienceGroups:', e);
      return [];
    }
  };
  const fetchSharedExperienceExperiences = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_experiences_by_shared_experiences_id', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('❌ Error in getSharedExperienceExperiences:', error);
        return [];
      }
      
      return data || [];
    } catch (e) {
      console.error('❌ Error in getSharedExperienceExperiences:', e);
      return [];
    }
  };
  const searchSharedExperiences = async (searchTerm) => {
    try {
      const { data, error } = await supabase.rpc('search_shared_experience', {
        arg_search_term: searchTerm
      });
      if (error) {
        console.error('Error in searchSharedExperiences:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Error in searchSharedExperiences:', e);
      throw e;
    }
  };
  const updateSharedExperienceGroup = async (groupId, updates) => {
    try {
      const { data, error } = await supabase.rpc('update_shared_experiences_group', {
        arg_group_id: groupId,
        arg_updates: updates
      });
      if (error) {
        console.error('Error in updateSharedExperienceGroup:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in updateSharedExperienceGroup:', e);
      throw e;
    }
  };
  const fetchPersonasNotInSharedExperience = async (sharedExperienceId, userId) => {
    try {
      const { data, error } = await supabase.rpc('get_persona_list_not_in_shared_experience_for_user', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: userId
      });
      if (error) {
        console.error('Error in fetchPersonasNotInSharedExperience:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Error in fetchPersonasNotInSharedExperience:', e);
      throw e;
    }
  };
  const fetchProductsNotInSharedExperience = async (sharedExperienceId, userId) => {
    try {
      const { data, error } = await supabase.rpc('get_products_not_in_shared_experience_for_user', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: userId
      });
      if (error) {
        console.error('Error in fetchProductsNotInSharedExperience:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Error in fetchProductsNotInSharedExperience:', e);
      throw e;
    }
  };
  const linkPersonaToSharedExperience = async (sharedExperienceId, personaId) => {
    try {
      const { data, error } = await supabase.rpc('add_shared_experiences_to_persona', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_persona_id: personaId,
        arg_group_id: null
      });
      if (error) {
        console.error('Error linking persona to shared experiences:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Exception in linkPersonaToSharedExperience:', e);
      throw e;
    }
  };
  const linkProductToSharedExperience = async (sharedExperienceId, productId) => {
    try {
      const { data, error } = await supabase.rpc('add_shared_experiences_to_product', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_product_id: productId,
        arg_group_id: null
      });
      if (error) {
        console.error('Error linking product to shared experiences:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Exception in linkProductToSharedExperience:', e);
      throw e;
    }
  };
  const fetchSharedExperiencesByPersonaId = async (personaId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experiences_by_persona_id', {
        arg_persona_id: personaId
      });
      if (error) {
        console.error('DB error:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Error getting shared experiences by persona ID:', e);
      throw e;
    }
  };
  const fetchSharedExperiencesByProductId = async (productId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experiences_by_product_id', {
        arg_product_id: productId
      });
      if (error) {
        console.error('DB error:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Exception in getSharedExperiencesByProductId:', e);
      throw e;
    }
  };
  const unlinkPersonaFromSharedExperience = async (sharedExperienceId, personaId) => {
    try {
      const { error } = await supabase.rpc('remove_shared_experience_from_persona', {
        arg_persona_id: personaId,
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error unlinking persona from shared experiences:', error);
        throw error;
      }
    } catch (e) {
      console.error('Exception in unlinkPersonaFromSharedExperience:', e);
      throw e;
    }
  };
  const unlinkProductFromSharedExperience = async (sharedExperienceId, productId) => {
    try {
      const { error } = await supabase.rpc('remove_shared_experience_from_product', {
        arg_product_id: productId,
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error unlinking product from shared experiences:', error);
        throw error;
      }
    } catch (e) {
      console.error('Exception in unlinkProductFromSharedExperience:', e);
      throw e;
    }
  };
  const fetchSharedExperienceMembers = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_members', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in getSharedExperienceMembers:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getSharedExperienceMembers:', e);
      throw e;
    }
  };
  const fetchMembersProfilesBySharedExperienceId = async (sharedExperienceId, status = null) => {
    try {
      const { data, error } = await supabase.rpc('get_members_profiles_by_shared_experiences_id', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_status: status
      });
      if (error) {
        console.error('Error in getMembersProfilesBySharedExperienceId:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getMembersProfilesBySharedExperienceId:', e);
      throw e;
    }
  };
  const fetchSharedExperienceOwnerById = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_owner_by_id', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in getSharedExperienceOwnerById:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getSharedExperienceOwnerById:', e);
      throw e;
    }
  };
  const fetchTemporaryUsersBySharedExperienceId = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_temporary_users_by_shared_experiences_id', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in getTemporaryUsersBySharedExperienceId:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getTemporaryUsersBySharedExperienceId:', e);
      throw e;
    }
  };
  const fetchUserRights = async (sharedExperienceId, profileId) => {
    try {
      let { data, error } = await supabase.rpc('fetch_user_rights_on_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: profileId
      });
      if (error) {
        console.error('Error in fetchUserRights:', error);
        throw error;
      } else if (data) {
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchMemberRole = async (sharedExperienceId, profileId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_member_role', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: profileId
      });
      if (error) {
        console.error('❌ Error in getMemberRole:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('❌ Exception in getMemberRole:', e);
      throw e;
    }
  };
  const fetchMemberStatus = async (sharedExperienceId, profileId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_member_status', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: profileId
      });
      if (error) {
        console.error('❌ Error in getMemberStatus:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('❌ Exception in getMemberStatus:', e);
      throw e;
    }
  };
  const hasRequestedEdition = async (sharedExperienceId, profileId) => {
    try {
      const { data, error } = await supabase.rpc('has_shared_experience_edit_request', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in hasRequestedEdition:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in hasRequestedEdition:', e);
      throw e;
    }
  };
  const addMembers = async (emails, sharedExperienceId, role) => {
    try {
      const promises = emails.map((email) => {
        return new Promise(async (resolve, reject) => {
          const result = await supabase.rpc('add_shared_experience_member', {
            arg_email: email,
            arg_shared_experiences_id: sharedExperienceId,
            arg_role: role
          });
          resolve(result);
        });
      });
      const result = await Promise.all(promises);
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  const revokeAccess = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('revoke_shared_experience_access', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in revokeAccess:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in revokeAccess:', e);
      throw e;
    }
  };
  const updateRole = async (sharedExperienceId, profileId, role) => {
    try {
      const { error } = await supabase.rpc('update_shared_experience_member_role', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId,
        arg_role: role
      });
      if (error) {
        console.error('Error in updateRole:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in updateRole:', e);
      throw e;
    }
  };
  const requestEdit = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('request_shared_experience_edit', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in requestEdit:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in requestEdit:', e);
      throw e;
    }
  };
  const approveRequest = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('approve_shared_experience_request', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in approveRequest:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in approveRequest:', e);
      throw e;
    }
  };
  const declineRequest = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('decline_shared_experience_request', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in declineRequest:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in declineRequest:', e);
      throw e;
    }
  };
  const approveMemberRequest = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('shared_experience_approve_request', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in approveMemberRequest:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in approveMemberRequest:', e);
      throw e;
    }
  };
  const declineMemberRequest = async (sharedExperienceId, profileId) => {
    try {
      const { error } = await supabase.rpc('shared_experience_decline_request', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_profile_id: profileId
      });
      if (error) {
        console.error('Error in declineMemberRequest:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in declineMemberRequest:', e);
      throw e;
    }
  };
  const fetchMembersData = async (sharedExperienceId, userId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experience_members_data', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_user_id: userId
      });
      if (error) {
        console.error('Error in getMembersData:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getMembersData:', e);
      throw e;
    }
  };
  const moveExperienceToGroup = async (sharedExperienceId, experienceId, groupId) => {
    try {
      const { data, error } = await supabase.rpc('move_experience_to_group_in_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_experience_id: experienceId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in moveExperienceToGroup:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in moveExperienceToGroup:', e);
      throw e;
    }
  };
  const moveGroupToGroup = async (groupId, targetGroupId, sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('move_group_to_group_in_shared_experience', {
        arg_group_id: groupId,
        arg_shared_experiences_id: sharedExperienceId,
        arg_parent_group_id: targetGroupId,
        arg_force: false
      });
      if (error) {
        console.error('Error in moveGroupToGroup:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in moveGroupToGroup:', e);
      throw e;
    }
  };
  const ungroupExperienceGroup = async (groupId) => {
    try {
      const { data, error } = await supabase.rpc('ungroup_shared_experiences_group', {
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in ungroupExperienceGroup:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in ungroupExperienceGroup:', e);
      throw e;
    }
  };
  const createExperienceGroup = async (name, sharedExperienceId, parentGroupId = null) => {
    try {
      const { data, error } = await supabase.rpc('create_shared_experiences_group', {
        arg_name: name,
        arg_shared_experiences_id: sharedExperienceId,
        arg_parent_group_id: parentGroupId
      });
      if (error) {
        console.error('Error in createExperienceGroup:', error);
        throw error;
      }
      
      return data;
    } catch (e) {
      console.error('Error in createExperienceGroup:', e);
      throw e;
    }
  };
  const fetchUngroupedExperiences = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_ungrouped_experiences_in_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in getUngroupedExperiences:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in getUngroupedExperiences:', e);
      throw e;
    }
  };
  const reorderItems = async (sharedExperienceId, groupId = null) => {
    try {
      const { data, error } = await supabase.rpc('reorder_shared_experience_items', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in reorderItems:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in reorderItems:', e);
      throw e;
    }
  };
  const removeExperienceFromSharedExperience = async (sharedExperienceId, experienceId) => {
    try {
      const { data, error } = await supabase.rpc('remove_experience_from_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_experience_id: experienceId
      });
      if (error) {
        console.error('Error in removeExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in removeExperience:', e);
      throw e;
    }
  };
  const addExperience = async (sharedExperienceId, experienceId, groupId = null) => {
    try {
      const { data, error } = await supabase.rpc('add_experience_to_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_experience_id: experienceId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in addExperience:', error);
        throw error;
      }
      
      return data;
    } catch (e) {
      console.error('Error in addExperience:', e);
      throw e;
    }
  };
  const moveSharedExperienceToGroupInPersona = async (personaId, sharedExperienceId, groupId) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences_persona')
        .update({ group_id: groupId })
        .eq('persona_id', personaId)
        .eq('shared_experiences_id', sharedExperienceId);
      if (error) {
        console.error('Error in moveSharedExperienceToGroupInPersona:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in moveSharedExperienceToGroupInPersona:', e);
      throw e;
    }
  };
  const moveSharedExperienceToGroupInProduct = async (productId, sharedExperienceId, groupId) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences_products')
        .update({ group_id: groupId })
        .eq('product_id', productId)
        .eq('shared_experiences_id', sharedExperienceId);
      if (error) {
        console.error('Error in moveSharedExperienceToGroupInProduct:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in moveSharedExperienceToGroupInProduct:', e);
      throw e;
    }
  };
  const updateOrderInSharedExperienceForImportedItems = async (sharedExperienceId, type, id, order, sourceSharedExperienceId) => {
    try {
      let { data, error } = await supabase.rpc('update_imported_item_order_in_shared_experience_with_reorder', {
        arg_type: type,
        arg_id: id,
        arg_order: order,
        arg_source_shared_experiences_id: sourceSharedExperienceId
      });
      if(error) {
        console.error('❌ Error in updateOrderInSharedExperienceForImportedItems:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ Exception in updateOrderInSharedExperienceForImportedItems:', e);
      throw e;
    }
  };
  const updateOrderInSharedExperience = async (type, id, order) => {
    try {
      let { data, error } = await supabase.rpc('update_order_in_shared_experience', {
        arg_type: type,
        arg_id: id,
        arg_order: order
      });
      
      if(error) {
        console.error('❌ [SHARED-API] Error in updateOrderInSharedExperience:', error);
        throw error
      }
    } catch (e) {
      console.error('❌ [SHARED-API] Exception in updateOrderInSharedExperience:', e);
      throw e;
    }
  };
  const addSharedExperienceToPersona = async (sharedExperienceId, personaId, groupId = null) => {
    try {
      const { data, error } = await supabase.rpc('add_shared_experiences_to_persona', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_persona_id: personaId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in addSharedExperienceToPersona:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in addSharedExperienceToPersona:', e);
      throw e;
    }
  };
  const addSharedExperienceToProduct = async (sharedExperienceId, productId, groupId = null) => {
    try {
      const { data, error } = await supabase.rpc('add_shared_experiences_to_product', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_product_id: productId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in addSharedExperienceToProduct:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in addSharedExperienceToProduct:', e);
      throw e;
    }
  };
  const addSharedExperienceToSharedExperience = async (sharedExperienceId, parentSharedExperienceId, groupId = null) => {
    try {
      const { data, error } = await supabase.rpc('add_shared_experiences_to_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_parent_shared_experiences_id: parentSharedExperienceId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('❌ Error in addSharedExperienceToSharedExperience:', error);
        if (error.message && error.message.includes('Circular reference detected')) {
          throw new Error('Cette action créerait une référence circulaire entre les shared experiences. Veuillez choisir un autre shared experience.');
        }
        throw error;
      }
      return data;
    } catch (e) {
      console.error('❌ Exception in addSharedExperienceToSharedExperience:', e);
      throw e;
    }
  };
  const removeSharedExperienceFromPersona = async (personaId, sharedExperienceId) => {
    try {
      const { error } = await supabase.rpc('remove_shared_experience_from_persona', {
        arg_persona_id: personaId,
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in removeSharedExperienceFromPersona:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in removeSharedExperienceFromPersona:', e);
      throw e;
    }
  };
  const removeSharedExperienceFromProduct = async (productId, sharedExperienceId) => {
    try {
      const { error } = await supabase.rpc('remove_shared_experience_from_product', {
        arg_product_id: productId,
        arg_shared_experiences_id: sharedExperienceId
      });
      if (error) {
        console.error('Error in removeSharedExperienceFromProduct:', error);
        throw error;
      }
    } catch (e) {
      console.error('Error in removeSharedExperienceFromProduct:', e);
      throw e;
    }
  };
  const removeSharedExperienceFromSharedExperience = async (parentSharedExperienceId, childSharedExperienceId) => {
    try {
      const { data, error } = await supabase.rpc('remove_shared_experience_from_shared_experience', {
        arg_parent_shared_experiences_id: parentSharedExperienceId,
        arg_child_shared_experiences_id: childSharedExperienceId
      });
      if (error) {
        console.error('Error in removeSharedExperienceFromSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in removeSharedExperienceFromSharedExperience:', e);
      throw e;
    }
  };
  const fetchSharedExperiencesBySharedExperienceId = async (sharedExperienceId) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences_shared_experiences')
        .select(`*, child_shared_experience:shared_experiences!child_shared_experiences_id(*)`)
        .eq('parent_shared_experiences_id', sharedExperienceId);
      if (error) {
        console.error('❌ API: getSharedExperiencesBySharedExperienceId error:', error);
        throw error;
      }
      return data || [];
    } catch (e) { 
      console.error('❌ API: getSharedExperiencesBySharedExperienceId exception:', e);
      throw e;
    }
  };
  const linkSharedExperienceToSharedExperience = async (parentSharedExperienceId, childSharedExperienceId) => {
    try {
      const { data, error } = await supabase
        .from('shared_experiences_shared_experiences')
        .insert({
          parent_shared_experiences_id: parentSharedExperienceId,
          child_shared_experiences_id: childSharedExperienceId
        })
        .select();
      if (error) {
        console.error('Error in linkSharedExperienceToSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Exception in linkSharedExperienceToSharedExperience:', e);
      throw e;
    }
  };

  const fetchAvailableSharedExperiencesForUser = async (userId, currentSharedExperienceId = null) => {
    try {
      const { data, error } = await supabase.rpc('get_available_shared_experiences_for_user', {
        arg_user_id: userId,
        arg_current_shared_experiences_id: currentSharedExperienceId
      });
      if (error) {
        console.error('Error in getAvailableSharedExperiencesForUser:', error);
        throw error;
      }
      return data || [];
    } catch (e) {
      console.error('Error in getAvailableSharedExperiencesForUser:', e);
      throw e;
    }
  };

  const fetchSharedExperiencesNotContainingExperience = async (userId, experienceId) => {
    try {
      const { data, error } = await supabase.rpc('get_shared_experiences_not_containing_experience', {
        arg_user_id: userId,
        arg_experience_id: experienceId
      });
      if (error) {
        console.error('Error in getSharedExperiencesNotContainingExperience:', error);
        return [];
      }
      return data || [];
    } catch (e) {
      console.error('Error in getSharedExperiencesNotContainingExperience:', e);
      return [];
    }
  };
  
  const convertGroupToSharedExperience = async (sharedExperienceId, groupId) => {
    try {
      const { data, error } = await supabase.rpc('convert_shared_experience_group_to_shared_experience', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_group_id: groupId
      });
      if (error) {
        console.error('Error in convertGroupToSharedExperience:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in convertGroupToSharedExperience:', e);
      throw e;
    }
  };
  const propagateGroupUngroupToPersonas = async (sharedExperienceId, groupName, parentGroupId = null) => {
    try {
      const { data, error } = await supabase.rpc('propagate_group_ungroup_to_personas', {
        arg_shared_experiences_id: sharedExperienceId,
        arg_group_name: groupName,
        arg_parent_group_id: parentGroupId
      });
      if (error) {
        console.error('Error in propagateGroupUngroupToPersonas:', error);
        throw error;
      }
      return data;
    } catch (e) {
      console.error('Error in propagateGroupUngroupToPersonas:', e);
      throw e;
    }
  };

  return {
    fetchSharedExperiencesByOrganisation,
    fetchSharedExperiencesByUserId,
    fetchSharedExperienceById,
    createSharedExperience,
    updateSharedExperienceName,
    updateAccessLevel,
    deleteSharedExperience,
    fetchSharedExperienceExperiences,
    searchSharedExperiences,
    updateSharedExperienceGroup,
    fetchPersonasNotInSharedExperience,
    fetchProductsNotInSharedExperience,
    linkPersonaToSharedExperience,
    linkProductToSharedExperience,
    fetchSharedExperiencesByPersonaId,
    fetchSharedExperiencesByProductId,
    unlinkPersonaFromSharedExperience,
    unlinkProductFromSharedExperience,
    fetchSharedExperienceMembers,
    fetchMembersProfilesBySharedExperienceId,
    fetchSharedExperienceOwnerById,
    fetchTemporaryUsersBySharedExperienceId,
    fetchUserRights,
    fetchMemberRole,
    fetchMemberStatus,
    hasRequestedEdition,
    addMembers,
    revokeAccess,
    updateRole,
    requestEdit,
    approveRequest,
    declineRequest,
    approveMemberRequest,
    declineMemberRequest,
    fetchMembersData,
    moveExperienceToGroup,
    moveGroupToGroup,
    ungroupExperienceGroup,
    createExperienceGroup,
    fetchUngroupedExperiences,
    reorderItems,
    removeExperienceFromSharedExperience,
    addExperience,
    moveSharedExperienceToGroupInPersona,
    moveSharedExperienceToGroupInProduct,
    updateOrderInSharedExperience,
    addSharedExperienceToPersona,
    addSharedExperienceToProduct,
    addSharedExperienceToSharedExperience,
    removeSharedExperienceFromPersona,
    removeSharedExperienceFromProduct,
    removeSharedExperienceFromSharedExperience,
    fetchSharedExperiencesBySharedExperienceId,
    linkSharedExperienceToSharedExperience,
    updateOrderInSharedExperienceForImportedItems,
    fetchAvailableSharedExperiencesForUser,
    fetchSharedExperiencesNotContainingExperience,
    convertGroupToSharedExperience,
  };
} 